<template>
  <div>
    <div class="bg-white text-center fixed inset-x-0 bottom-0 z-10 border-t">
      <div class="container mx-auto grid grid-cols-5 p-0 sm:w-full md:w-5/12">

        <router-link :to="{name: 'home'}" class="py-3 hover:text-teal-500 block text-center transition-all duration-200 border-b-2 border-transparent hover:border-teal-500">
          <img width="25" height="25" class="inline-block mb-1" src="@/assets/images/home.png">
          <span class="block text-xs">Beranda</span>
        </router-link>

        <router-link :to="{name: 'donation.index'}" class="py-3 hover:text-teal-500 block text-center transition-all duration-200 border-b-2 border-transparent hover:border-teal-500">
          <img width="25" height="25" class="inline-block mb-1" src="@/assets/images/heart.png">
          <span class="block text-xs">Donasi Saya</span>
        </router-link>

        <router-link :to="{name: 'campaign.index'}" class="py-3 hover:text-teal-500 block text-center transition-all duration-200 border-b-2 border-transparent hover:border-teal-500">
          <img width="25" height="25" class="inline-block mb-1" src="@/assets/images/flag.png">
          <span class="block text-xs">Campaign</span>
        </router-link>

        <router-link :to="{name: 'login'}" class="py-3 hover:text-teal-500 block text-center transition-all duration-200 border-b-2 border-transparent hover:border-teal-500">
          <img width="25" height="25" class="inline-block mb-1" src="@/assets/images/user.png">
          <span class="block text-xs">Akun</span>
        </router-link>

        <router-link :to="{name: 'about'}" class="py-3 hover:text-teal-500 block text-center transition-all duration-200 border-b-2 border-transparent hover:border-teal-500">
          <img width="25" height="25" class="inline-block mb-1" src="@/assets/images/info.png">
          <span class="block text-xs">Tentang</span>
        </router-link>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>
